<template>
  <ExternalQueryList
      endpoint="/api/v2/projects"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      @show="project => $router.push(getUrl(project))"
  >
    <template v-slot:default="{ row: project }">
      <td class="table__ellipsis">
        <router-link :to="getUrl(project)">
          {{ project.attributes.name }}
        </router-link>
      </td>

      <td class="table__ellipsis">
        {{ project.attributes.project_category_name }}
      </td>

      <td class="table__ellipsis">
          <router-link :to="'/portals/' + project.attributes.portal_id">
            {{ project.attributes.portal_name }}
          </router-link>
      </td>

      <td class="table__ellipsis">
        {{ project.attributes.revenue | price }}
      </td>

      <td class="table__ellipsis">
        <span v-if="project.attributes.ends_at">
          {{ project.attributes.ends_at | date }}
        </span>

        <span v-else>
          N/A
        </span>
      </td>

      <td>
        <Avatar
            v-for="projectManager in project.attributes.project_managers" :key="projectManager.user_id"
            :color="projectManager.user_color"
        >
          {{ projectManager.user_initials }}
        </Avatar>
      </td>

      <td>
        <Avatar
            v-for="projectSeller in project.attributes.project_sellers" :key="projectSeller.user_id"
            :color="projectSeller.user_color"
        >
          {{ projectSeller.user_initials }}
        </Avatar>
      </td>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'
import Avatar from "../../../Avatar.vue";

export default {
  components: {Avatar, ExternalQueryList},

  props: {
    portals: {
      required: true,
      type: Array
    },
  },

  computed: {
    headlines() {
      return [
        {width: 5, text: 'Name'},
        {width: 2, text: 'Category'},
        {width: 3, text: 'Portal'},
        {width: 2, text: 'Revenue'},
        {width: 2, text: 'Publish Date'},
        {width: 3, text: 'Managers'},
        {width: 3, text: 'Sales Team'},
      ]
    },

    filters() {
      return [
        [
          {
            widget: 'text',
            name: 'search',
            width: 8
          },
          {
            widget: 'select',
            name: 'portal_id',
            width: 4,
            nullable: true,
            placeholder: '(all portals)',
            options: this.portals.map(portal => ({value: portal.id, label: portal.attributes.name}))
          },
          {
            width: 4,
            widget: 'typeahead',
            name: 'project_manager_id',
            placeholder: '(all project managers)',
            endpoint: '/api/v2/users',
            resultLabelProperty: row => row.attributes.full_name
          },
          {
            widget: 'select',
            name: 'status',
            width: 4,
            nullable: true,
            placeholder: '(all statuses)',
            options: [{value: 'active', label: 'Active'}, {value: 'expired', label: 'Expired'}]
          },
          {
            widget: 'submit',
            width: 4
          },
        ]
      ]
    }
  },

  methods: {
    getUrl(project) {
      return '/projects/' + project.id
    }
  }
}
</script>
